/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ia4moxahgnhkdglkyuuunpd63q.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-jeeel4n5qvgujhu7trnasuk6oe",
    "aws_cognito_identity_pool_id": "us-east-1:98a7c71c-e468-410d-96fd-d85e8e31df7e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_auCDskee6",
    "aws_user_pools_web_client_id": "2mtgnji68vpbjpfq1qd4s096ln",
    "oauth": {
        "domain": "authedcsquared-master.auth.us-east-1.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "https://app.edcsquared.io/dashboard",
        "redirectSignOut": "https://app.edcsquared.io/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "NAME",
        "FAMILY_NAME",
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "edcsquared-20240329211157-hostingbucket-live",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d366sec9qdj1y4.cloudfront.net",
    "aws_user_files_s3_bucket": "user-storage91541-master",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
